
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.772549 0 0 0 0 0.772549 0 0 0 0 0.772549 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-136 -34)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M148 34c-6.626 0-12 5.374-12 12s5.374 12 12 12 12-5.374 12-12-5.374-12-12-12zm6.02 9.182v1.624a5.67 5.67 0 01-3.469-1.179l.011 5.002a4.183 4.183 0 01-1.257 2.98 4.27 4.27 0 01-3.034 1.243 4.29 4.29 0 01-3.034-1.242 4.193 4.193 0 01-1.249-3.266 4.193 4.193 0 011.059-2.532 4.289 4.289 0 013.224-1.442c.218 0 .434.016.645.047v2.273a2.027 2.027 0 00-2.668 1.953c.01.724.407 1.357.99 1.706a2.025 2.025 0 001.678.185 2.025 2.025 0 001.392-1.922l.002-3.349v-6.115h2.238a3.47 3.47 0 003.466 3.431h.006v.603z"}})])])
          )
        }
      }
    